import axios from "axios";
import { DEFAULT_TIMEOUT } from "./timeout";

export const client = axios.create({
  baseURL: process.env.REACT_APP_LOYALTY_API_URL,
  timeout: DEFAULT_TIMEOUT,
});
